// extracted by mini-css-extract-plugin
export var statItem = "_cb-1";
export var statsRow = "_cb-0";